import config from '../../config';

const getAPIKey = () => {
	const apiKey = config.REACT_APP_GEOCODING_API_KEY ||'';
	return apiKey;
}

const handleGeocodeResponse = (response) => {
	return response.text().then((text) => {
		try{
			const json = JSON.parse(text);
			const tmp = json.results.map((result) => {
				const topLeft = [
					result.geometry.viewport.northeast.lat,
					result.geometry.viewport.southwest.lng,
				];

				const bottomRight = [
					result.geometry.viewport.southwest.lat,
					result.geometry.viewport.northeast.lng,
				];

				let country = 'AU';

				result.address_components.forEach((comp) => {
					if (comp.types.indexOf('country') >= 0) {
						country = comp.short_name;
					}
				});

				return {
					placeId: result.place_id,
					country: country,
					formattedAddress: result.formatted_address,
					location: result.geometry.location,
					bounds: result.geometry.viewport,
				}
			});
			return tmp;
		} catch(e){
			return Promise.reject({ error: response.status, json: {} });
		}
	});
}

export default function geocode(searchQuery){
	const url = 'https://maps.googleapis.com/maps/api/geocode/json?address='+ encodeURI(searchQuery) +'&key=' + getAPIKey();
	return fetch(url).then(handleGeocodeResponse);
}


// WEBPACK FOOTER //
// ./src/shared/api/geocode.js